/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyAzureDevopsIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-azure-devops" */ './utils').then((m) => m.AzureDevopsIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/azure-devops/icon' },
);

const LazyAzureDevopsSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-azure-devops-search-result" */ './utils').then(
			(m) => m.AzureDevopsSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/azure-devops/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const AzureDevopsIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAzureDevopsIconComponent />
	</Suspense>
);

export const AzureDevopsSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAzureDevopsSearchResultIconComponent />
	</Suspense>
);
